import { useEffect } from "react";

import type { SlotItem } from "../../dashboard/utils";
import { formatDueTime } from "../../dashboard/utils";
import { CloseOutActions } from "./CloseOutActions";
import { StepCard } from "./StepCard";

interface CloseOutStepProps {
  readonly openSlots: SlotItem[];
  readonly onDone: () => void;
}

export function CloseOutStep({ openSlots, onDone }: CloseOutStepProps) {
  useEffect(() => {
    if (openSlots.length === 0) onDone();
  }, [openSlots.length, onDone]);

  if (openSlots.length === 0) return null;

  const current = openSlots[0]!;

  return (
    <StepCard
      title={current.slot.name}
      subtitle={`${current.goalName} · was due ${formatDueTime(current.slot.dueTimeLocal)} · ${openSlots.length} left to decide`}
    >
      <CloseOutActions key={current.slot.id} item={current} />
    </StepCard>
  );
}
